// Маппинг доменных состояний сделки в визуальные токены (цвет + i18n-ключ). Чистая логика —
// без JSX/иконок, чтобы покрыть тестами; иконки выбирает компонент-бейдж. См. §9: статус всегда
// цвет + текст (+ иконку даёт компонент), никогда «только цвет».

import type { BargainStatus, DealOrderType, SignatureState } from '@/types/deals';
import { STATUS } from '@/lib/statusColors';

export interface BadgeView {
  readonly color: string;
  readonly labelKey: string;
}

/** Верхнеуровневый статус сделки. Неизвестный статус — нейтральный серый, без падения. */
export function dealStatusView(status: BargainStatus | undefined): BadgeView {
  switch (status) {
    case 'IN_PROGRESS':
      return { color: STATUS.active, labelKey: 'app.deals.status.inProgress' };
    case 'WAIT_BPMN':
      return { color: STATUS.neutral, labelKey: 'app.deals.status.waitBpmn' };
    case 'CLOSED':
      return { color: STATUS.done, labelKey: 'app.deals.status.closed' };
    case 'CANCELED':
      return { color: STATUS.danger, labelKey: 'app.deals.status.canceled' };
    default:
      return { color: STATUS.neutral, labelKey: 'app.deals.status.unknown' };
  }
}

/** Состояние подписи документа (роль-подписант). EDO/BES различаем на стороне компонента. */
export function signatureStateView(state: SignatureState | undefined): BadgeView | null {
  switch (state) {
    case 'DONE':
      return { color: STATUS.done, labelKey: 'app.deals.sign.done' };
    case 'WAITED':
      return { color: STATUS.waiting, labelKey: 'app.deals.sign.waited' };
    case 'WRONG':
    case 'UNEXPECTED':
      return { color: STATUS.danger, labelKey: 'app.deals.sign.wrong' };
    case 'NOT_REQUIRED':
    default:
      return null; // подпись не требуется от этой роли — бейдж не рисуем
  }
}

/** Вкладка списка из ?tab= (по умолчанию продажи). */
export function parseDealTab(value: string | null): DealOrderType {
  return value === 'purchase' ? 'PURCHASE' : 'SALE';
}
